import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import BrandNav from "../components/BrandNav";
import { useAuth } from "../lib/auth";
import { extractError } from "../lib/format";

export default function Login() {
  const { t } = useTranslation("common");
  const { login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const dest = location.state?.from?.pathname || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
      toast.success(t("auth.login.toastSuccess"));
      nav(dest, { replace: true });
    } catch (e) {
      setErr(extractError(e, t("auth.login.errorFallback")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page">
      <BrandNav />
      <main className="ftg-shell ftg-page">
        <div className="ftg-auth">
          <h1>{t("auth.login.title")}</h1>
          <p className="ftg-auth__sub">{t("auth.login.sub")}</p>
          <form className="ftg-form" onSubmit={submit} data-testid="login-form">
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="login-email">{t("auth.email")}</label>
              <input
                id="login-email"
                className="ftg-field__input"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
              />
            </div>
            <div className="ftg-field">
              <label className="ftg-field__label" htmlFor="login-pw">{t("auth.password")}</label>
              <input
                id="login-pw"
                className="ftg-field__input"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
              />
            </div>
            {err ? (
              <div className="ftg-form__error" data-testid="login-error">
                {err}
              </div>
            ) : null}
            <button
              type="submit"
              className="ftg-btn ftg-btn--primary ftg-btn--block ftg-btn--large"
              disabled={busy}
              data-testid="login-submit-btn"
            >
              {busy ? t("auth.login.submitBusy") : t("auth.login.submitIdle")}
            </button>
          </form>
          <div className="ftg-auth__foot">
            <Link to="/forgot-password" data-testid="login-forgot-link">{t("auth.login.forgotLink")}</Link>
            <span> · </span>
            <Link to="/signup" data-testid="login-signup-link">{t("auth.login.signupLink")}</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
